import { TextBox } from "../types";

export const getSettingsForIsDark = (textBox: TextBox, isDark: boolean): Partial<Omit<TextBox, "id">> => {
    return {
        fontColor: isDark ? "white" : "black",
        shadow: textBox.shadow
            ? {
                  ...textBox.shadow,
                  color: isDark ? "black" : "white",
              }
            : undefined,
        outline: textBox.outline ? { ...textBox.outline, color: isDark ? "black" : "white" } : undefined,
    };
};
